import useUnitHeartbeat from './useUnitHeartbeat';

export default function useMobileHeartbeat(user, gps, division) {
  return useUnitHeartbeat(user, gps, division);
}
